'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Plane = require('./Plane');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plane).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Plane/index.js
// module id = 1256
// module chunks = 1